<template>
  <v-app-bar
    flat
    color="transparent"
    class="app-bar-responsive"
    height="auto"
    :class="[
      'app-bar-responsive',
      staticPosition ? 'position-static' : 'position-absolute',
      isHome ? 'home-page' : '',
    ]"
  >
    <!-- Botão de voltar no topo -->
    <v-btn
      v-if="returnFocus"
      variant="text"
      class="voltar-btn-searchbar"
      @click="voltar"
    >
      <v-icon start class="voltar-icon-searchbar">mdi-chevron-left</v-icon>
      VOLTAR
    </v-btn>

    <div :class="['logo-search-wrapper', { 'search-page-layout': hideTitle }]">
      <div class="logo-container">
        <router-link to="/">
          <img
            src="@/assets/images/logo.png"
            alt="Logo Tigre"
            max-height="40"
            contain
          />
        </router-link>
      </div>

      <h1 v-if="hideTitle" class="search-page-title">{{ pageTitle }}</h1>

      <v-responsive
        :max-width="expandido ? 400 : 300"
        class="search-wrapper transition-width"
      >
        <v-text-field
          :placeholder="placeholderText"
          v-model="filtros.busca"
          @keydown.enter="buscar"
          prepend-inner-icon="mdi-magnify"
          @click:prepend-inner="onClickLupa"
          @focus="onFocusOuClick"
          @blur="onBlur"
          variant="outlined"
          hide-details
          rounded
          clearable
          density="comfortable"
          class="search-field white-field"
        />
      </v-responsive>
    </div>
  </v-app-bar>
</template>

<script setup>
import { ref, watch, toRef } from "vue";
import { useRouter } from "vue-router";
import { useProdutos } from "@/composables/useProdutos";

const props = defineProps({
  modelValue: String,
  hideTitle: Boolean,
  pageTitle: String,
  staticPosition: Boolean,
  isHome: Boolean,
  returnFocus: Boolean,
});

const emit = defineEmits(["update:modelValue"]);

const router = useRouter();
const { filtros } = useProdutos();

const expandido = ref(false);
const placeholderText = ref("Buscar");

watch(
  () => props.modelValue,
  (val) => {
    filtros.value.busca = val || "";
  },
  { immediate: true }
);

const buscar = () => {
  const termo = filtros.value.busca.trim();
  if (termo !== "") {
    router.push({ name: "Busca", query: { q: termo } });
  }
};

const onClickLupa = () => {
  if (filtros.value.busca && filtros.value.busca.trim() !== "") {
    buscar();
  }
  onFocusOuClick();
};

const onFocusOuClick = () => {
  expandido.value = true;
  placeholderText.value = "Digite o nome ou o código do produto";
};

const onBlur = () => {
  //filtros.value.busca = "";
  expandido.value = false;
  placeholderText.value = "Buscar";
};

const voltar = () => {
  router.push({ name: "Home" });
};
</script>

<style scoped>
.voltar-btn-searchbar {
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  color: #102954 !important;
  text-transform: none;
  min-width: 0;
  padding-left: 0;
  position: absolute;
  right: 16px;
  top: 10px;
  z-index: 10;
}

.voltar-icon-searchbar {
  color: #102954 !important;
  font-size: 30px;
}

.transition-width {
  transition: max-width 0.3s ease;
}

.white-field {
  background-color: transparent !important;
  color: black !important;
}

::v-deep(.white-field .v-field__input) {
  color: #102954 !important;
  font-family: "Ubuntu", sans-serif !important;
  font-weight: 400 !important;
  font-style: italic !important;
  font-size: 14px !important;
}

::v-deep(.white-field .v-field__outline)::before {
  content: "";
  pointer-events: none;
  position: absolute;
  inset: 0;
  border-radius: 28px;
  padding: 2px;
  background: linear-gradient(90deg, #004c97, #0493d4);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: destination-out;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  box-sizing: border-box;
  z-index: 1;
}

::v-deep(.white-field .v-field__control) {
  position: relative;
  z-index: 2;
  background: white !important;
  border-radius: 26px;
}

::v-deep(.white-field .v-field__prepend-inner .v-icon) {
  background: linear-gradient(90deg, #004c97, #0493d4);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.app-bar-responsive {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
}

.logo-search-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
}

.logo-container {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.search-wrapper {
  margin-left: auto;
}

.search-page-title {
  margin: 0;
  font-weight: 700;
  font-size: 32px;
  font-family: "Ubuntu", sans-serif !important;
  text-align: center;
  width: 100%;
  color: #0a4488;
}

.search-wrapper {
  margin-top: 0 !important;
}

.position-absolute {
  position: absolute;
  padding: 0;
}

.position-static {
  position: static !important;
  padding: 0;
}

.home-page .logo-search-wrapper {
  padding: 50px 100px;
}

@media (max-width: 1200px) {
  .home-page .logo-search-wrapper {
    padding: 50px 60px 60px 60px;
  }
  .home-page .logo-search-wrapper {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    padding: 20px !important;
  }

  .home-page .logo-container {
    padding: 0;
  }

  .home-page .search-wrapper {
    flex: 1 1 auto;
    max-width: 300px;
  }

  .home-page .search-field {
    width: 100%;
    max-width: 100% !important;
  }
}

@media (min-width: 600px) {
  .search-page-layout {
    display: block;
    width: 100%;
  }
  .search-page-layout .logo-container {
    margin-bottom: 16px;
  }
  .search-page-layout .search-page-title {
    width: 100%;
    margin-bottom: 8px;
  }
  .search-page-layout .search-wrapper {
    max-width: 400px !important;
    margin: 0 auto !important;
  }
}

@media (max-width: 600px) {
  .logo-search-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .search-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }

  .logo-container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .v-btn--size-default {
    padding: 0 !important;  }
}

@media (max-width: 468px) {
  .home-page .logo-container img {
    display: block;
    max-height: 30px;
  }

  .search-field.white-field ::v-deep(.v-field__input) {
    min-height: 42px !important;
    height: 42px !important;
  }

  .search-field.white-field ::v-deep(.v-field__prepend-inner) {
    height: 42px !important;
  }

  .logo-search-wrapper {
    align-items: center;
  }

  .search-page-layout .logo-container img {
    max-height: 30px;
  }

  .voltar-btn-searchbar {
    right: 0px;
    top: 0px;
  }  
}

@media (max-width: 364px) {
  .home-page .logo-container img {
    max-height: 24px;
  }

  .search-field.white-field ::v-deep(.v-field__input) {
    min-height: 36px !important;
    height: 36px !important;
  }

  .search-field.white-field ::v-deep(.v-field__prepend-inner) {
    height: 36px !important;
  }

  .logo-search-wrapper {
    align-items: center;
  }

  .search-page-layout .logo-container img {
    max-height: 24px;
  }

  .voltar-btn-searchbar {
    top: -5px;
    font-size: 10px;
    padding-left: 120px;
  }

  .voltar-icon-searchbar {
    font-size: 20px;
  }
}
</style>
